import {
  FiscalArchiveFilters,
  GtPeriodicFilters,
  JetEventsFilters,
  Paginated,
  Sortable,
  SourceDocumentFilters,
} from "@ac-expo/api-types";

export const nf525QueryKeys = {
  all: ["nf525"] as const,

  jetEvents: (filters?: Sortable<Paginated<JetEventsFilters>>) =>
    [...nf525QueryKeys.all, "jet-events", filters] as const,

  sourceDocuments: (filters?: Sortable<Paginated<SourceDocumentFilters>>) =>
    [...nf525QueryKeys.all, "source-documents", filters] as const,

  gtPeriodic: (filters?: Sortable<Paginated<GtPeriodicFilters>>) =>
    [...nf525QueryKeys.all, "gt-periodic", filters] as const,

  fiscalArchives: (tenantId: string, filters?: FiscalArchiveFilters) =>
    [...nf525QueryKeys.all, "fiscal-archives", tenantId, filters] as const,

  fiscalArchiveDownload: (archiveId: string) =>
    [...nf525QueryKeys.all, "fiscal-archive-download", archiveId] as const,

  missingClosures: () => [...nf525QueryKeys.all, "missing-closures"] as const,
};
